import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';
import LegalPageLayoutV2 from '@/components/marketing/legal/v2/LegalPageLayoutV2';

export default function DataDeletion() {
  const { t } = useTranslation('marketing');

  return (
    <>
      <SEOHead
        title="Suppression de vos données — Velko POS"
        description="Demander la suppression de vos données personnelles Velko POS : procédure, délais, données effacées. Conforme aux exigences Meta, Google, Apple."
        path="/suppression-donnees"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Suppression des données', path: '/suppression-donnees' },
        ]}
      />
      <LegalPageLayoutV2
        kind="data-deletion"
        subtitle={t('dataDeletion.heroSubtitle')}
        lastUpdated={t('dataDeletion.lastUpdated')}
        content={t('dataDeletion.content')}
        contactTitle="Demander la suppression de vos données"
        contactDesc="Envoie un email à openintech@gmail.com avec l'objet « Suppression données ». On confirme dans les 7 jours et on supprime sous 30 jours."
        contactEmail="openintech@gmail.com"
      />
    </>
  );
}
